export const CompassMarkNeutral = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.5 23.179V32.092H14.57V23.179H23.5V14.272H7.20997C6.33997 14.278 5.63997 14.976 5.64597 15.832C5.64597 15.839 5.64597 15.846 5.64597 15.853V39.465C5.62797 40.321 6.31897 41.028 7.18797 41.046C7.19497 41.046 7.20297 41.046 7.20997 41.046H30.844C31.714 41.04 32.414 40.342 32.408 39.486C32.408 39.479 32.408 39.472 32.408 39.465V23.179H23.5Z"
      fill="url(#paint0_linear_818_481)"
    />
    <path
      d="M23.5 5.35987V14.2719H32.451V23.1789H41.354V6.91987C41.372 6.06387 40.681 5.35687 39.812 5.33887C39.805 5.33887 39.797 5.33887 39.79 5.33887L23.5 5.35987Z"
      fill="#758195"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_481"
        x1="30.859"
        y1="15.827"
        x2="15.688"
        y2="30.998"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.2" stopColor="#2C3E5D" />
        <stop offset="1" stopColor="#758195" />
      </linearGradient>
    </defs>
  </svg>
);
